export default "__VITE_ASSET__328cb223__"